import { render, staticRenderFns } from "./intValue.vue?vue&type=template&id=90a3468c"
import script from "./intValue.vue?vue&type=script&lang=ts"
export * from "./intValue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports